import React from 'react';
import Menu from './Menu.js';
export const Header = () => (React.createElement("header", null,
    React.createElement(Menu, null)));
